export type Reason = {
  title: string
  description: string
}

export const reasons: Reason[] = [
  {
    title: 'Safety First, Always',
    description:
      'Every surgical case is performed in a fully accredited facility with board-certified anesthesia and pre-operative medical clearance.',
  },
  {
    title: 'Personalized Consultation',
    description:
      'Unhurried, one-on-one time with Dr. Sara. No sales scripts, no packages, no pressure to decide in the room.',
  },
  {
    title: 'Expert Evaluation',
    description:
      'Anatomical assessment, imaging review and honest candidacy screening — including telling you when surgery is the wrong answer.',
  },
  {
    title: 'Surgical Excellence',
    description:
      'Refined techniques with a bias toward natural proportion, minimal scarring and results that age well over decades.',
  },
  {
    title: 'Structured Aftercare',
    description:
      'Scheduled follow-ups at week one, month one and month six, plus lymphatic massage and scar therapy built into your plan.',
  },
  {
    title: 'Complete Discretion',
    description:
      'Private entrance, single-patient scheduling blocks and a concierge team trained to protect your privacy end to end.',
  },
]
